import Popover, { PopoverPosition, PopoverOrigin } from '@mui/material/Popover';
import Fade from '@mui/material/Fade';
import Grow from '@mui/material/Grow';
import { ReactNode, RefObject } from 'react';

interface Props {
  open?: boolean;
  onClose: any;
  maxWidth?: number | string;
  maxHeight?: number | string;
  anchorReference?: 'anchorEl' | 'anchorPosition';
  anchor?: HTMLElement | null;
  anchorPosition?: PopoverPosition;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  marginThreshold?: number;
  children: ReactNode;
  className?: string;
  transition?: 'fade' | 'grow';
  disableBackdrop?: boolean;
  isKeepMounted?: boolean;
}

export type { PopoverPosition };

export default function Component(props: Props) {
  const open = props.open ?? Boolean(props.anchor || props.anchorPosition);

  return (
    <Popover
      keepMounted={props.isKeepMounted ?? true}
      className={props.className}
      disableAutoFocus
      anchorReference={props.anchorReference || 'anchorEl'}
      anchorEl={props.anchor}
      anchorPosition={props.anchorPosition}
      open={open}
      // elevation={1}
      onClose={props.onClose}
      TransitionComponent={props.transition === 'grow' ? Grow : Fade}
      anchorOrigin={
        props.anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'left',
        }
      }
      transformOrigin={
        props.transformOrigin || {
          vertical: 'top',
          horizontal: 'left',
        }
      }
      marginThreshold={props.marginThreshold}
      PaperProps={{
        style: {
          maxHeight: props.maxHeight,
          width: props.maxWidth,
          borderRadius: 8,
          boxShadow: '0px 8px 20px 0px rgba(0, 0, 0, 0.15)',
          pointerEvents: props.disableBackdrop ? 'auto' : undefined,
        },
      }}
      disableEnforceFocus={props.disableBackdrop}
      style={{
        pointerEvents: props.disableBackdrop ? 'none' : undefined,
      }}
    >
      {props.children}
    </Popover>
  );
}
